import { OptionType } from '@/ui/components/Form/Select/types';

const emptySelectOption: OptionType<string> = {
  label: '',
  value: ''
};

export default emptySelectOption;
